import React, { useCallback, useState } from "react";
import { registerLocale } from "react-datepicker";
import DatePicker from "../../../components/DatePickerInput";
import Label from "./LabelF";
import "react-datepicker/dist/react-datepicker.css";
import ar from "date-fns/locale/es";
import { TextField } from "@mui/material";
import "../filtros.scss";
import { parseISOString } from "../../../context/FuncionesContext";
import { parseFechaFormato } from "../../../helper/funciones";

registerLocale("ar", ar);

const Fecha = (props) => {
  const {
    id_a,
    setFiltrosAAplicar,
    setError,
    filtrosAAplicar,
    operador,
    componente,
    grid_span,
    error,
    aplicarFiltroValorActivo,
    placeholder,
  } = props;

  const parseFecha = useCallback((fecha) => {
    if (!fecha) return [undefined];

    try {
      if (Array.isArray(JSON.parse(fecha))) {
        let fechas = JSON.parse(fecha);

        if (fechas[0]) fechas[0] = parseISOString(fechas[0]);
        if (fechas[1]) fechas[1] = parseISOString(fechas[1]);
        return fechas;
      }
      return [parseISOString(fecha)];
    } catch (e) {
      return [parseISOString(fecha)];
    }
  }, []);

  const [fechas, setFechas] = useState([
    parseFecha(filtrosAAplicar[id_a])[0],
    parseFecha(filtrosAAplicar[id_a])[1],
  ]);

  const startDate = parseFecha(filtrosAAplicar[id_a])[0];

  const endDate = parseFecha(filtrosAAplicar[id_a])[1];

  const styles = {
    gridColumn: grid_span,
    // height: "82.3px",
  };

  const fecha_formato = (() => {
    if (props.fecha_formato && props.fecha_formato !== "")
      return props.fecha_formato;
    if (operador !== "fecha_hora") return "dd/MM/yyyy";
    return "dd/MM/yyyy, hh:mm";
  })();

  const {
    showTimeSelect,
    showTimeSelectOnly,
    timeFormat,
    dateFormat: fechaFormato,
    timeIntervals,
  } = parseFechaFormato(fecha_formato);

  const placeHolder = placeholder?.split(",");

  return (
    <div className="filtroFecha" style={styles}>
      {/* <button onClick={() => console.log(fechas)}>ver fechas</button> */}
      <div>
        <Label
          label={props.label}
          opcionales_null={props.opcionales_null}
          permite_null={props.permite_null}
        />
        <div className="filtro_grid_fecha">
          <DatePicker
            className="fecha_input"
            fechaMinima={props.fecha_minima}
            showTimeSelect={showTimeSelect}
            showTimeSelectOnly={showTimeSelectOnly}
            timeFormat={timeFormat}
            timeIntervals={timeIntervals}
            showYearDropdown={
              fecha_formato ? fecha_formato.includes("yy") : true
            }
            showFullMonthYearPicker
            dateFormat={fechaFormato}
            locale="ar"
            placeholderText={placeHolder?.[0] || "Desde"}
            onChange={(date) => {
              //setStartDate(date);
              const nuevasFechas = [...fechas];
              nuevasFechas[0] = date?.toISOString();

              setFechas((s) => {
                return nuevasFechas;
              });
              aplicarFiltroValorActivo(date, { nuevasFechas });
            }}
            selectsStart
            selected={parseISOString(fechas[0])}
            startDate={parseISOString(fechas[0])}
            endDate={parseISOString(fechas[1])}
            // minDate={fechas[0]}
            customInput={
              <TextField
                label={placeHolder?.[0] || "Desde"}
                variant="standard"
                error={error[id_a]}
              />
            }
            isClearable
            label={placeHolder?.[0] || "Desde"}
            // withPortal
          />
          {componente === "fecha_simple" ? null : (
            <DatePicker
              className="fecha_input"
              fechaMinima={props.fecha_minima}
              showTimeSelect={showTimeSelect}
              showTimeSelectOnly={showTimeSelectOnly}
              timeFormat={timeFormat}
              timeIntervals={timeIntervals}
              showYearDropdown={
                fecha_formato ? fecha_formato.includes("yy") : true
              }
              showDateSelect={false}
              dateFormat={fecha_formato}
              locale="ar"
              placeholderText={placeHolder?.[1] || " Hasta"}
              onChange={(date) => {
                //setEndDate(date);
                const nuevasFechas = [...fechas];
                nuevasFechas[1] = date?.toISOString();
                setFechas((s) => {
                  return nuevasFechas;
                });
                aplicarFiltroValorActivo(date, { nuevasFechas });
              }}
              selectsEnd
              selected={parseISOString(fechas[1])}
              startDate={parseISOString(fechas[0])}
              endDate={parseISOString(fechas[1])}
              minDate={parseISOString(fechas[0]) ?? null}
              customInput={
                <TextField
                  label={placeHolder?.[1] || " Hasta"}
                  variant="standard"
                  error={error[id_a]}
                />
              }
              isClearable
              // withPortal
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Fecha;
